import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faBook, faCoffee, faExternalLinkAlt, faFileAlt, faLock, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Button, Card, Container, Form, InputGroup } from '@themesberg/react-bootstrap';

export default () => {
  return (
    <Container className="mt-4">
      {/* Hero Section */}
      <div className="text-center mb-5">
        <h1 className="display-4 fw-bold">Sé Productivo: Aprende - Haciendo</h1>
        <Card className="p-4 shadow-sm" style={{ textAlign: 'justify' }}>
          <p className="lead mt-3">
            Inscríbase y use gratis al simulador <strong>MI MODELO DE NEGOCIO</strong>, el software para crear, fortalecer o reactivar empresas que reúne a:
          </p>
          <ul className="list-unstyled text-muted">
            <li>1) Los Emprendedores o “user”, quienes con él hacen su modelo de negocio;</li>
            <li>2) Los profesores o “expert”, quienes apoyan la construcción de los modelos de negocio y los califican; y</li>
            <li>3) Los potenciales inversores o “contributor”, quienes buscan modelos de negocio para invertir.</li>
          </ul>
          <p>
            Al reunirse vía web o personalmente, podrán organizar e implementar proyectos empresariales capaces de generar riqueza.
          </p>
        </Card>
      </div>

      <Row>
        {/* Universal Format Form Placeholder */}
        <Col md={12} lg={6} className="mb-4">
          <Card border="light" className="shadow-sm">
            <Card.Header>
              <h5><FontAwesomeIcon icon={faUserPlus} className="me-2" /> Formato UNIVERSAL</h5>
            </Card.Header>
            <Card.Body>
              <Form>
                <p className="text-muted small">Diligencie para entrar a la plataforma.</p>
                <Form.Group className="mb-3" controlId="formName">
                  <Form.Label>Nombre Completo</Form.Label>
                  <Form.Control type="text" placeholder="Ingrese su nombre" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Correo Electrónico</Form.Label>
                  <Form.Control type="email" placeholder="Ingrese su correo" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formProject">
                  <Form.Label>Nombre del Proyecto</Form.Label>
                  <Form.Control type="text" placeholder="Mi Empresa..." />
                </Form.Group>
                <Button variant="primary" type="submit" className="w-100">
                  Registrar
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        {/* Links & Resources */}
        <Col md={12} lg={6}>
          {/* External Links */}
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body>
              <div className="d-grid gap-2">
                <Button variant="outline-primary" href="https://www.productivos.org" target="_blank">
                  <FontAwesomeIcon icon={faYoutube} className="me-2" /> Canal CIEM POR 100 EMPRESAS
                </Button>
                <Button variant="outline-secondary">
                  <FontAwesomeIcon icon={faLock} className="me-2" /> Términos de Privacidad
                </Button>
              </div>
            </Card.Body>
          </Card>

          {/* Books & Articles */}
          <Card border="light" className="shadow-sm mb-4">
            <Card.Header>
              <h6><FontAwesomeIcon icon={faBook} className="me-2" /> Libros y Artículos</h6>
            </Card.Header>
            <Card.Body>
              <ul className="list-group list-group-flush">
                <li className="list-group-item"><a href="#">Libro 1: Emprendimiento Ágil</a></li>
                <li className="list-group-item"><a href="#">Artículo: Modelos de Negocio</a></li>
                <li className="list-group-item"><a href="#">Guía: Finanzas para Startups</a></li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Donations */}
      <Row className="mt-4">
        <Col xs={12}>
          <Card className="bg-primary text-white text-center p-4">
            <blockquote className="blockquote mb-0">
              <p>
                <FontAwesomeIcon icon={faCoffee} className="me-2" /> <strong>INVITAME UN CAFÉ</strong>
              </p>
              <footer className="blockquote-footer text-white">
                Pruebe el simulador MI MODELO DE NEGOCIO y valore el modelo CIEM. Si considera que son herramientas útiles,
                apoye su sostenimiento y actualización.
              </footer>
            </blockquote>
            <div className="mt-3">
              <p className="mb-1"><strong>Cuenta en Colombia:</strong> [Número de Cuenta]</p>
              <p className="mb-0"><strong>Cuenta otros países:</strong> [Enlace/Cuenta]</p>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Sponsors */}
      <Row className="mt-4 mb-5">
        <Col xs={12}>
          <Card border="light" className="text-center p-5 border-dashed">
            <h5 className="text-muted">Espacio para Publicidad de Sponsors</h5>
            <p>Aquí aparecerán los aliados que apoyan esta iniciativa.</p>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
